module.exports = __webpack_public_path__ + "static/img/logo_light_mini.33dbd40d.png";